<template>
  <div class="w-100">
    <div class="overlay" :class="create_report ? 'open' : ''" @click="closeCreateReport()"></div>
    <div class="pr-detail-modal" :class="create_report ? 'open' : ''">
      <div class="request-pr-wrap">
        <div class="request-pr-title" style="font-size: 16px">
          新規レポート作成
          <div class="report-create-subtitle" v-if="create_type == 'auto' && create_page >= 2">条件を設定して自動作成</div>
          <div class="report-create-subtitle" v-else-if="create_type == 'manual' && create_page >= 2">エクセル/CSVからインポート
          </div>
        </div>
        <div class="request-pr-step">
          <el-steps v-if="create_type == 'auto'" :active="create_page" align-center style="padding:0 20px">
            <el-step description="基本設定" @click.native="create_page = 1"></el-step>
            <el-step description="インフルエンサー選択" @click.native="create_page = 2"></el-step>
            <el-step description="トラッキング設定" @click.native="create_page = 3"></el-step>
          </el-steps>
          <el-steps v-if="create_type == 'manual'" :active="create_page" align-center style="padding:0 20px">
            <el-step description="基本設定" @click.native="create_page = 1"></el-step>
            <el-step description="ファイルアップロード" @click.native="create_page = 2"></el-step>
            <el-step description="内容確認・期間設定" @click.native="create_page = 3"></el-step>
          </el-steps>
        </div>
        <div class="request-pr-form">
          <div v-show="create_page == 1">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">レポートの作成形式を選択してください</div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">レポートタイトル(任意)</div>
                <el-input type="text" v-model="report.report_name" placeholder="レポートタイトルを入力して下さい" maxlength="50"
                          show-word-limit id="autoFocus"></el-input>
              </div>
              <div class="create-report-sns-wrap">
                <div class="create-report-sns" @click="create_type = 'auto'"
                     :class="create_type == 'auto' ? 'active' : ''">
                  <div class="create-report-sns-title">
                    条件を設定して自動作成
                    <div class="create-list-check">
                      <font-awesome-icon :icon="['fas', 'check-circle']" v-show="create_type == 'auto'"/>
                    </div>
                  </div>
                  <font-awesome-icon :icon="['fal', 'bolt-auto']" style="margin: 20px; font-size:20px"/>
                  <div class="create-report-sns-description">条件によりレポートを自動作成します。<br/>レポートは対象期間中自動で更新されます。
                  </div>
                </div>
                <div class="create-report-sns right" @click="create_type = 'manual'"
                     :class="create_type == 'manual' ? 'active' : ''">
                  <div class="create-report-sns-title">
                    エクセル/CSVからインポート
                    <div class="create-list-check">
                      <font-awesome-icon :icon="['fas', 'check-circle']" v-show="create_type == 'manual'"/>
                    </div>
                  </div>
                  <font-awesome-icon :icon="['fal', 'file-csv']" style="margin: 20px; font-size:20px"/>
                  <div class="create-report-sns-description">エクセル/CSVファイルから手動作成します。 <br/>レポートは自動更新されません。</div>
                  <div class="new-tag small" style="position:absolute; top:10px; left:10px">NEW</div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="activate == 11 || activate > 15">
                <el-checkbox class="checkbox-show checkbox-small" v-model="report.assign">
                  自分をレポート担当メンバーに割り当てる
                </el-checkbox>
              </div>
            </div>
            <div class="request-pr-form-buttonarea">
              <el-button @click="createReportPageNext()" type="primary">次へ</el-button>
            </div>
          </div>
          <div v-if="create_page == 2 && create_type == 'auto'">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                レポート測定したいインフルエンサーを選択してください
              </div>
              <div class="request-pr-form-parts" style="flex-flow: column">
                <ul class="request-pr-form-description">
                  <li>追加したインフルエンサーの投稿を自動で取得・トラッキングします。</li>
                  <li style="margin-bottom:0">インフルエンサーの追加は後から行うこともできます。</li>
                </ul>
              </div>

              <influencerSuggest
                @syncInfluencerList="syncInfluencerList('instagram', $event)"
                :referer="'report'"
                :sns_type="'instagram'"
                :influencer_list.sync="report.instagram.influencer_list"
                :report_switch.sync="report.instagram.report_switch"
                :checkList.sync="report.instagram.checkList"
                :allCheckLists="allCheckLists"
              />
              
              <hr class="sns-divider" />
              
              <influencerSuggest
                @syncInfluencerList="syncInfluencerList('tiktok', $event)"
                :referer="'report'"
                :sns_type="'tiktok'"
                :influencer_list.sync="report.tiktok.influencer_list"
                :report_switch.sync="report.tiktok.report_switch"
                :checkList.sync="report.tiktok.checkList"
                :allCheckLists="allCheckLists"
              />
              
              <hr class="sns-divider" />

              <influencerSuggest
                @syncInfluencerList="syncInfluencerList('twitter', $event)"
                :referer="'report'"
                :sns_type="'twitter'"
                :influencer_list.sync="report.twitter.influencer_list"
                :report_switch.sync="report.twitter.report_switch"
                :checkList.sync="report.twitter.checkList"
                :allCheckLists="allCheckLists"
              />
              
            </div>
            
            <div class="request-pr-form-buttonarea">
              <div class="report-detail-noinfluencer">
                追加したいインフルエンサーが登録されていない場合は
                <router-link to="/request" target="_blank">
                  <span class="router-link"
                  >こちら
                    <font-awesome-icon :icon="['far', 'external-link']" style="margin-right: 3px;"/>
                  </span>
                </router-link>
                からリクエストできます
              </div>
              <div class="flex-space"></div>
              <el-button @click="createReportPageBack()" type="primary">戻る</el-button>
              <el-button @click="createReportPageNext()" type="primary">次へ</el-button>
            </div>
          </div>
          <div v-if="create_page == 3 && create_type == 'auto'">
            <div class="request-pr-form-wrap">
              <div class="request-pr-form-title">
                トラッキング用のタグと期間を設定してください
              </div>
              <div class="request-pr-form-parts" style="margin-bottom: 20px">
                <ul class="request-pr-form-description">
                  <li>設定したトラッキング期間中、レポートにアサインされたインフルエンサーの投稿のうち、指定のハッシュタグもしくはメンションタグ、キーワードを含む投稿を自動で取得します。</li>
                  <li>ハッシュタグでトラッキングする場合は、ブランド名やキャンペーン名を含むようなユニークなハッシュタグを設定してください。</li>
                  <li style="margin-bottom:0">トラッキングタグが設定されていない場合は、トラッキング期間中の全ての投稿を取得します。</li>
                </ul>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">
                  トラッキングタグ
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input" style="margin-top:10px">
                    <el-radio v-model="report.trackingtag" label="on" style="margin-right: 20px;">設定する</el-radio>
                    <el-tooltip :disabled="totalInfluencerCount < 50" placement="top-end">
                      <div slot="content">インフルエンサーを50人以上選択する場合はトラッキングタグ設定が必須です</div>
                      <span>
                        <el-radio v-model="report.trackingtag" label="off"
                                  :disabled="totalInfluencerCount >= 50">設定しない(トラッキング期間の全投稿を取得)</el-radio>
                      </span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  ハッシュタグ(最大3つ)
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input">
                    <el-input @keyup.enter.native="addHashtag()" @blur="enter_on ? '' : addHashtag()"
                              v-model="hashtagValue" placeholder="ハッシュタグを入力(Enterで追加)">
                      <template slot="prepend">
                        <font-awesome-icon :icon="['fal', 'hashtag']"/>
                      </template>
                    </el-input>
                    <div class="request-pr-form-hashtag-num">{{ report.hash_tag_json.length }}/3</div>
                  </div>
                  <div class="request-pr-form-hashtag-wrap">
                    <div class="request-pr-form-hashtagbox" v-for="hashtag in report.hash_tag_json" :key="hashtag.id">
                      {{ hashtag }}
                      <div :key="hashtag" @click="deleteHashtag(hashtag)" v-if="report.request_status != 'request'">
                        <font-awesome-icon :icon="['fas', 'times']"
                                           style="cursor: pointer;margin-left: 10px;font-size: 14px;"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  メンションタグ(最大1つ)
                </div>
                <div class="request-pr-form-mentiontag">
                  <div class="request-pr-form-mentiontag-input">
                    <el-input @keyup.enter.native="addMentiontag()" @blur="enter_on ? '' : addMentiontag()"
                              v-model="mentiontagValue" placeholder="メンションタグを入力(Enterで追加)">
                      <template slot="prepend">
                        <font-awesome-icon :icon="['fal', 'at']"/>
                      </template>
                    </el-input>
                    <div class="request-pr-form-mentiontag-num">{{ report.mention_tag_json.length }}/1</div>
                  </div>
                  <div class="request-pr-form-mentiontag-wrap">
                    <div class="request-pr-form-mentiontagbox" v-for="mentiontag in report.mention_tag_json" :key="mentiontag.id">
                      {{ mentiontag }}
                      <div :key="mentiontag" @click="deleteMentiontag(mentiontag)" v-if="report.request_status !== 'request'">
                        <font-awesome-icon :icon="['fas', 'times']"
                                           style="cursor: pointer;margin-left: 10px;font-size: 14px;"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts" v-if="report.trackingtag == 'on'">
                <div class="request-pr-form-subtitle">
                  キーワード(最大3つ)
                </div>
                <div class="request-pr-form-hashtag">
                  <div class="request-pr-form-hashtag-input">
                    <el-input @keyup.enter.native="addKeyword()" @blur="enter_on ? '' : addKeyword()"
                              v-model="keywordValue" placeholder="キーワードを入力(Enterで追加)">
                      <template slot="prepend">
                        <font-awesome-icon :icon="['fal', 'search']" />
                      </template>
                    </el-input>
                    <div class="request-pr-form-hashtag-num">{{ report.keyword_json.length }}/3</div>
                  </div>
                  <div class="request-pr-form-hashtag-wrap">
                    <div class="request-pr-form-hashtagbox" v-for="keyword in report.keyword_json" :key="keyword.id">
                      {{ keyword }}
                      <div :key="hashtag" @click="deleteKeyword(keyword)" v-if="report.request_status != 'request'">
                        <font-awesome-icon :icon="['fas', 'times']"
                                           style="cursor: pointer;margin-left: 10px;font-size: 14px;"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-pr-form-parts">
                <div class="request-pr-form-subtitle">
                  トラッキング期間
                  <el-tooltip>
                    <div slot="content">
                      最大2ヶ月間自動でトラッキングを行います
                    </div>
                    <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 3px; color: #aaa"/>
                  </el-tooltip>
                </div>
                <el-date-picker
                    v-model="report.tracking_date"
                    type="daterange"
                    start-placeholder="開始日"
                    end-placeholder="終了日"
                    format="yyyy/MM/dd"
                    value-format="yyyy/MM/dd"
                    align="right"
                    clearable
                    :picker-options="pickerOptions"
                    :default-value="default_date"
                ></el-date-picker>
              </div>
            </div>
            <div class="request-pr-form-buttonarea">
              <el-button @click="createReportPageBack()" type="primary">戻る</el-button>
              <el-button @click="activate == 12 && active_report_count >= 10 ? '' : createReport()" type="success"
                         :disabled="create_loading || (activate == 12 && active_report_count >= 10)">
                <div class="flex-row">
                  レポートを作成
                  <div class="loader--mini" v-show="create_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
          <div v-if="create_page >= 2 && create_type == 'manual'">
            <reportCreateUpload :create_page.sync="create_page" :create_type="create_type" :report="report"
                                @closeDrawer="closeCreateReport()"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const createReportAPI = root + "/api/report/create_report";
import influencerSuggest from "./influencer_suggest";
import reportCreateUpload from "./report_create_upload";
import { isOutsideAdminPastTrackingRange, isOutsideTrackingRangeEnd } from "@/utils/trackingDatePicker";

export default {
  name: "reportCreateDrawer",
  components: {
    influencerSuggest,
    reportCreateUpload,
  },
  props: ["active_report_count", "create_report"],
  data() {
    return {
      create_report_id: "",
      create_type: "auto",
      report_name: "",
      nolist: "",
      count: 0,
      drawer: false,
      index: 0,
      create_page: 1,
      hashtagValue: "",
      mentiontagValue: "",
      keywordValue: "",
      dynamicTags: [],
      dynamicmentionTags: [],
      report: {
        report_name: "",
        influencer: "",
        trackingtag: "on",
        hash_tag_json: [],
        mention_tag_json: [],
        keyword_json: [],
        tracking_date: "",
        list_value: "",
        assign: true,        
        instagram: {
          influencer_list: [],
          report_switch: "left",
          checkList: [],
        },
        tiktok: {
          influencer_list: [],
          report_switch: "left",
          checkList: [],
        },
        twitter: {
          influencer_list: [],
          report_switch: "left",
          checkList: [],
        },
        sns_type: "instagram",
      },
      create_loading: false,
      selectData: "",
      pickerOptions: {
        disabledDate: this.disabledDate,
        onPick: this.onPick,
      },
      default_date: new Date().setMonth(new Date().getMonth() - 1),
      enter_on: false,
      change_report: false,
      target_report_id: 0,
      target_report_index: 0,
      target_report_name: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.report;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    isAdminUser() {
      return this.activate === 20 && this.admin_mode;
    },
    totalInfluencerCount() {
      return (
        (this.report.instagram.influencer_list || []).length +
        (this.report.tiktok.influencer_list || []).length +
        (this.report.twitter.influencer_list || []).length
      );
    },
    allCheckLists() {
      return {
        instagram: this.report.instagram.checkList,
        tiktok: this.report.tiktok.checkList,
        twitter: this.report.twitter.checkList,
      };
    },
    notag_error() {
      if (this.report.hash_tag_json.length == 0 && this.report.mention_tag_json.length == 0 && this.report.keyword_json.length == 0) {
        var no_tag = true;
      }
      if (this.report.instagram.influencer_list.length >= 50) {
        var over_influencer = true;
      }
      if (no_tag && over_influencer) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
  },
  methods: {
    onPick(time) {
      this.selectData = time.minDate.getTime();
      if (time.maxDate) this.selectData = "";
    },
    disabledDate(time) {
      const startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);

      // 管理者モードかつ過去のみの期間選択時: 開始日は無制限、終了日は開始日から最大6ヶ月
      if (this.isAdminUser) {
        const isPastDate = time.getTime() < startOfToday.getTime();
        if (!this.selectData && isPastDate) {
          return false;
        }
        if (this.selectData) {
          const start = new Date(this.selectData);
          const startIsPast = start.getTime() < startOfToday.getTime();
          if (startIsPast && isPastDate) {
            return isOutsideAdminPastTrackingRange(start, time);
          }
        }
      }

      if (this.selectData) {
        return isOutsideTrackingRangeEnd(this.selectData, time);
      } else {
        var dt = new Date();
        dt.setMonth(dt.getMonth() - 5);
        dt.setDate(dt.getDate() - 1);
        return time.getTime() < dt;
      }
    },
    closeCreateReport() {
      this.$emit("closeCreateReport");
      document.documentElement.style.overflow = "auto";
    },
    addHashtag() {
      this.enter_on = true;
      if (this.report.hash_tag_json.length > 2 && this.hashtagValue) {
        this.$message({
          type: "error",
          message: "ハッシュタグは最大3件までしか登録できません",
        });
      } else {
        let hashtagValue = this.hashtagValue;
        if (hashtagValue) {
          this.report.hash_tag_json.push("#" + this.hashtagValue);
        }
        this.hashtagValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    addKeyword() {
      this.enter_on = true;
      if (this.report.keyword_json.length > 2 && this.keywordValue) {
        this.$message({
          type: "error",
          message: "キーワードは最大3件までしか登録できません",
        });
      } else {
        let keywordValue = this.keywordValue;
        if (keywordValue) {
          this.report.keyword_json.push(this.keywordValue);
        }
        this.keywordValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    deleteHashtag(hashtag) {
      this.report.hash_tag_json.splice(this.report.hash_tag_json.indexOf(hashtag), 1);
    },
    deleteKeyword(keyword) {
      this.report.keyword_json.splice(this.report.keyword_json.indexOf(keyword), 1);
    },
    addMentiontag() {
      this.enter_on = true;
      if (this.report.mention_tag_json.length > 0 && this.mentiontagValue) {
        this.$message({
          type: "error",
          message: "メンションタグは最大1件までしか登録できません",
        });
      } else {
        let mentiontagValue = this.mentiontagValue;
        if (mentiontagValue) {
          this.report.mention_tag_json.push("@" + this.mentiontagValue);
        }
        this.mentiontagValue = "";
      }
      setTimeout(() => {
        this.enter_on = false;
      }, 200);
    },
    deleteMentiontag(mentiontag) {
      this.report.mention_tag_json.splice(this.report.mention_tag_json.indexOf(mentiontag), 1);
    },
    syncMentiontag(value) {
      this.report.mention_tag_json = value;
    },
    syncInfluencerList(snsType, value) {
      this.report[snsType].influencer_list = value;
    },
    createReport() {
      if (this.report.instagram.influencer_list.length == 0 && this.report.tiktok.influencer_list.length == 0 && this.report.twitter.influencer_list.length == 0) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "インフルエンサーが選択されていません",
        });
      } else if (this.report.tracking_date == "" || this.report.tracking_date == null) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "トラッキング期間が設定されていません",
        });
      } else if (this.notag_error) {
        this.$message({
          type: "error",
          offset: 7,
          showClose: true,
          message: "インフルエンサーを50人以上選択する場合はトラッキングタグ設定が必須です",
        });
      } else {
        this.create_loading = true;
        var params = new URLSearchParams();
        params.append("report_name", this.report.report_name);
        params.append("sns_type", this.report.sns_type);
        params.append("trackingtag", this.report.trackingtag);
        params.append("influencer", JSON.stringify(this.report.instagram.influencer_list));
        params.append("influencer_tiktok", JSON.stringify(this.report.tiktok.influencer_list));
        params.append("influencer_x", JSON.stringify(this.report.twitter.influencer_list));
        params.append("hashtag", JSON.stringify(this.report.trackingtag == "on" ? this.report.hash_tag_json : []));
        params.append("mentiontag", JSON.stringify(this.report.trackingtag == "on" ? this.report.mention_tag_json : []));
        params.append("keyword", JSON.stringify(this.report.trackingtag == "on" ? this.report.keyword_json : []));
        params.append("sns_type", this.report.sns_type);
        params.append("start_at", this.report.tracking_date[0]);
        params.append("end_at", this.report.tracking_date[1]);
        params.append("assign", this.activate == 11 || this.activate > 15 ? this.report.assign : false);
        params.append("user_token", this.user_token);
        params.append("token", this.token);
        this.axios
            .post(createReportAPI, params)
            .then((response) => {
              if (response.data.status === "NG") {
                this.create_loading = false;
                this.$message({
                  type: "error",
                  offset: 7,
                  showClose: true,
                  message: response.data.message || "レポートの作成に失敗しました",
                });
                return;
              }
              this.create_report_id = response.data.report_id;
              this.create_loading = false;
              this.$emit("closeCreateReport");
              this.create_page = 1;
              this.report.report_name = "";
              this.report.instagram.influencer_list = [];
              this.report.tiktok.influencer_list = [];
              this.report.twitter.influencer_list = [];
              this.report.hash_tag_json = [];
              this.report.mention_tag_json = [];
              this.report.keyword_json = [];
              this.report.tracking_date = "";
              this.report.instagram.checkList = [];
              this.report.tiktok.checkList = [];
              this.report.twitter.checkList = [];
              this.infiniteId += 1;
              this.$emit("loadReport");
              this.$alert("レポートの作成には2~3分程度時間がかかります。レポートはトラッキング期間中、24時間毎に自動で更新されます。", "レポートを作成中です", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
            })
            .catch((error) => {
              this.create_loading = false;
              let error_message = "レポートの作成に失敗しました";

              // クラウドフロント側でタイムアウトされた場合は反映に時間がかかる旨を表示しレポート作成フォームをリセット
              if (error.response.status == 504) {
                error_message = "サーバーが混み合っております。ブラウザをリロードいただき操作内容が反映されていない場合は、しばらく時間をおいて再度操作をお願いいたします。";
                this.$emit("closeCreateReport");
                this.create_page = 1;
                this.report.report_name = "";
                this.report.instagram.influencer_list = [];
                this.report.tiktok.influencer_list = [];
                this.report.twitter.influencer_list = [];
                this.report.hash_tag_json = [];
                this.report.mention_tag_json = [];
                this.report.keyword_json = [];
                this.report.tracking_date = "";
                this.report.instagram.checkList = [];
                this.report.tiktok.checkList = [];
                this.report.twitter.checkList = [];
                this.infiniteId += 1;
                this.$emit("loadReport");
              }

              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: error_message,
              });
            });
      }
    },
    createReportPageBack() {
      this.create_page -= 1;
    },
    createReportPageNext() {
      this.create_page += 1;
    },
  },
  watch: {
    report: {
      handler() {
        if ((this.report.instagram.influencer_list.length + this.report.tiktok.influencer_list.length + this.report.twitter.influencer_list.length) >= 50) {
          this.report.trackingtag = "on";
        }
        if (this.report.trackingtag == "off") {
          this.hash_tag_json = [];
          this.mention_tag_json = [];
          this.keyword_json = [];
        }
      },
      deep: true,
    },
  },
  filters: {
    lastUpadate(val) {
      const now = new Date();
      const lastUpdate = new Date(val);
      const diffSec = now.getTime() - lastUpdate.getTime();
      if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
  },
};
</script>
